/** Textos de Eventos (FASE 4). */
const S = {
	title: "Eventos",
	nuevo: "Nuevo Evento",
	volver: "Volver",
	cerrar: "Cerrar",
	buscar: "Buscar evento",
	cargando: "Cargando…",
	vacio: "Sin eventos con ese filtro.",
	todos: "Todos",
	tipos: { graduacion: "Graduación", batalla: "Batalla", seminario: "Seminario", otro: "Otro" } as { [k: string]: string },
	estados: { programado: "Programado", realizado: "Realizado", anulado: "Anulado", historico: "Histórico" } as { [k: string]: string },
	col: { fecha: "Fecha", evento: "Evento", tipo: "Tipo", lugar: "Lugar", asistentes: "Asistentes", paquete: "Paquete", estado: "Estado" },
	// Formulario
	editar: "Editar",
	guardar: "Guardar",
	crear: "Crear Evento",
	tipo: "Tipo",
	nombre: "Nombre",
	fecha: "Fecha y hora",
	lugar: "Lugar",
	cupo: "Cupo Máximo",
	porMesa: "Personas por mesa",
	paquete: "Paquete graduada",
	invitadoExtra: "Invitado Extra (6+)",
	nino: "Niño",
	paquetes: "Paquete Invitados",
	extras: "Extras",
	extraEjemplo: "Diploma Extra",
	agregarExtra: "Agregar Extra",
	ahorra: (t: string) => `Ahorra ${t}`,
	sinAhorro: "Sin ahorro",
	ninoGratis: "Niño gratis",
	nInvitados: (n: number) => `${n} invitados`,
	paqueteCorto: (n: number, t: string, nino: boolean) => `${n} por ${t}` + (nino ? " + niño gratis" : ""),
	gratisPaquete: "Gratis (paquete)",
	lugarInvitado: (k: number, paquete: string | null) => `Invitado ${k} de esta graduada` + (paquete ? ` · paquete ${paquete}` : ""),
	ninoGratisAviso: "Niño gratis por el paquete de invitados.",
	costos: "Costos",
	costosOk: "Costos guardados.",
	concepto: "Concepto",
	monto: "Monto",
	agregarCosto: "Agregar Costo",
	quitar: "Quitar",
	notas: "Notas",
	estado: "Estado",
	guardado: "Evento guardado.",
	creado: "Evento creado.",
	historicoAviso: "Evento histórico: solo lectura.",
	// Pestañas
	tabs: { asistentes: "Asistentes", elegibles: "Elegibles", invitaciones: "Invitaciones", extras: "Extras", entrada: "Entrada", resultado: "Resultado" },
	// Extras vendidos
	venderExtra: "Vender Extra",
	extraDe: "Para",
	extraCual: "Extra",
	colExtra: "Extra",
	colEntregado: "Entregado",
	sinExtras: "Sin extras vendidos.",
	extraOk: "Extra agregado; el cobro ya está en Caja.",
	extraQuitado: "Extra quitado.",
	nPorEntregar: (n: number) => `${n} por entregar`,
	porEntregar: "Por entregar",
	deBaja: "De baja",
	// Varios invitados a la vez
	nombresInvitados: "Nombres, si ya los sabe (uno por renglón)",
	cuantos: "Cuántos",
	masInvitados: "+ Invitados",
	ponerNombre: "Nombre",
	nombreTitulo: (n: string) => `Nombre de ${n}`,
	faltanNombres: (n: number) => n === 1 ? "falta 1 nombre" : `faltan ${n} nombres`,
	agregarVarios: (n: number) => n > 1 ? `Agregar ${n}` : "Agregar",
	invitadosAgregados: (n: number) => n === 1 ? "Invitado agregado." : `${n} invitados agregados.`,
	totalPaquete: (n: number, t: string, mas: string) => `${n} invitados de esta graduada: ${t} en total · se cobran ${mas} más`,
	// Asistentes
	colNo: "No.",
	colNombre: "Nombre",
	colTipo: "Tipo",
	colMesa: "Mesa",
	colPago: "Pago",
	colFoto: "Foto",
	colDiploma: "Diploma",
	colEntrada: "Entrada",
	pagado: "Pagado",
	porPagar: "Por pagar",
	sinCobro: "Sin cobro",
	diplomaListo: "Listo",
	falta: (x: string[]) => "Falta: " + x.join(", "),
	subirFoto: "Subir Foto",
	cambiarFoto: "Cambiar",
	verFoto: "Ver",
	fotoOk: "Foto guardada.",
	invitacionPdf: "Invitación",
	diplomaPdf: "Diploma",
	baja: "Baja",
	bajaTitulo: (n: string) => `Baja de ${n}`,
	bajaNota: "Nota",
	bajaOk: "Dada de baja.",
	// Baja con dinero (fase 2)
	bajaSalen: "Salen",
	bajaPago: "Pagó",
	bajaSeQueda: "Se queda",
	bajaSobran: "Sobran",
	bajaSoloCaja: "Solo Caja, Contraloría o Super Admin dan de baja a quien ya pagó.",
	bajaDestino: "Destino del Sobrante",
	destinos: { saldo: "Saldo a Favor", aplicar: "Pagar Cobros Pendientes", devolucion: "Devolución en Efectivo" } as { [k: string]: string },
	bajaNotaDevolucion: "Nota (obligatoria)",
	bajaOkDestino: (d: string, monto: string) => d === "saldo" ? `Dada de baja · ${monto} a saldo a favor.`
		: d === "aplicar" ? `Dada de baja · ${monto} aplicado a cobros pendientes.` : `Dada de baja · devolver ${monto} en efectivo.`,
	invitaA: (n: string) => `Invita ${n}`,
	agregarAsistente: "Agregar Asistente",
	kinds: { graduada: "Graduada", invitado: "Invitado", especial: "Especial", externo: "Externo", participante: "Participante" } as { [k: string]: string },
	motivoPrecio: "Motivo",
	precioEvento: "Precio del evento",
	invitaGraduada: "Graduada que invita",
	elegir: "Elegir…",
	esNino: "Niño",
	precio: "Precio",
	seCobra: "Se cobra",
	buscarAlumna: "Nombre o código de la alumna",
	buscarBtn: "Buscar",
	agregarBtn: "Agregar",
	agregado: "Asistente agregado.",
	sinAsistentes: "Sin asistentes.",
	vigentes: (n: number) => `${n} vigentes`,
	repartirMesas: "Repartir Mesas",
	repartirTitulo: "Repartir Mesas",
	conservarManuales: "Conservar las mesas puestas a mano",
	repartir: "Repartir",
	mesasOk: "Mesas repartidas.",
	verQr: "Ver QR",
	qrDe: (n: string) => `QR de ${n}`,
	// Invitaciones
	pdfTodas: "PDF de Todas",
	whatsappVarias: (n: number) => `WhatsApp a ${n}`,
	colWhatsapp: "WhatsApp",
	colEnlace: "Enlace",
	copiar: "Copiar",
	copiado: "Copiado.",
	sinTelefono: "Sin teléfono",
	seleccionadas: (n: number) => `${n} elegidas`,
	// Grupos por graduada (fase 2)
	grupos: "Grupos",
	colGrupo: "Graduada",
	colEnvio: "Envío",
	nPersonas: (n: number) => n === 1 ? "1 persona" : `${n} personas`,
	pagadoCompleto: "Pagado Completo",
	faltaMonto: (m: string) => `Falta ${m}`,
	enviada: (cuando: string, via: string) => `Enviada ${cuando}` + (via ? ` · ${via}` : ""),
	sinEnviar: "Sin enviar",
	via: { whatsapp: "WhatsApp", email: "correo" } as { [k: string]: string },
	y: " y ",
	copiarEnlace: "Copiar Enlace",
	abrir: "Abrir",
	enviarAhora: "Enviar Ahora",
	enviando: "Enviando…",
	waEnviado: "WhatsApp enviado",
	waError: (e: string) => `WhatsApp: ${e}`,
	correoEnviado: "Correo enviado",
	sinCorreo: "Sin correo",
	correoError: (e: string) => `Correo: ${e}`,
	// Elegibles
	elegTodas: "Todas",
	elegListas: "Diploma Listo",
	elegReponer: "Por Reponer",
	cursoTodos: "Todos los cursos",
	buscarElegible: "Buscar alumna",
	colCurso: "Curso",
	colTermina: "Termina",
	colAsistencia: "Asistencia",
	colEstado: "Estado",
	nPorReponer: (n: number) => `${n} por reponer`,
	yaAgregada: "Agregada",
	agregarN: (n: number) => `Agregar ${n}`,
	cobraPaquete: "Se cobra el paquete",
	agregadas: (a: number, s: number) => `Agregadas ${a}` + (s ? ` · sin agregar ${s}` : "") + ".",
	mostrando: (n: number, t: number) => `${n} de ${t}`,
	// Entrada
	codigo: "Código QR",
	leer: "Leer",
	escanearCamara: "Escanear con Cámara",
	camaraTitulo: "Escanear Invitación",
	camaraPrendiendo: "Prendiendo la cámara…",
	camaraSinPermiso: "Permite la cámara en el navegador y vuelve a abrir.",
	camaraNoSoporta: "Este navegador no puede usar la cámara.",
	camaraApunta: "Apunta al código QR",
	cerrarCamara: "Cerrar",
	entradas: (n: number, t: number) => `${n} de ${t} adentro`,
	rehabilitar: "Re-habilitar",
	rehabTitulo: (n: string) => `Re-habilitar a ${n}`,
	rehabNota: "Motivo",
	rehabOk: "Invitación re-habilitada.",
	lecturas: "Lecturas",
	acciones: { entrada: "Entrada", rechazada: "Rechazada", rehabilitada: "Re-habilitada" } as { [k: string]: string },
	// Resultado
	ingresos: "Ingresos",
	cobrado: "Cobrado",
	pendiente: "Pendiente",
	costosTotal: "Costos",
	bruto: "Bruto",
	brutoCobrado: "Bruto cobrado",
	porTipo: "Por tipo",
	cantidad: "Cantidad",
	mesas: "Mesas",
	togas: "Togas y Birretes",
	asistentesVigentes: "Asistentes",
	bajasPagadas: "Bajas con Pago",
	colSobro: "Sobró",
	colDestino: "Destino",
	colQuien: "Quién",
	colCuando: "Cuándo",
	colNota: "Nota"
};

export default S;
